<template>
  <div class="username-step">
    <div class="username-step__container">
      <h2
        class="username-step__headline"
        v-html="$options.filters.md(`You're all set up :white_check_mark:`)">
      </h2>

      <div
        class="username-step__description"
        v-html="$options.filters.md(`Before you start the quest, let's set up your username. It'll be used as the main character's name and displayed on the leaderboard.\n\nIf you skip this step, you'll be assigned a default username — AVG Joe. :wink:`)">
      </div>

      <div class="username-step__form">
        <input
          ref="usernameInput"
          type="text"
          placeholder="Choose your username"
          name="username"
          class="username-step__input"
          v-model="value"
          v-on:change="handleValueChange"
          v-on:keydown="handleKeyDown">

        <div class="username-step__input-hint">
          Your username will be publicly visible on the leaderboard and will be used in email communications. Choose something you're comfortable sharing!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestUsernameStep",
  data() {
    return {
      value: ""
    }
  },
  props: ["username"],
  methods: {
    handleValueChange() {
      this.$emit("toggle-username", this.value);
    },
    handleKeyDown(event) {
      if (event.key === "Enter" || (event.key === "Enter" && (event.metaKey || event.ctrlKey))) {
        event.preventDefault();
        this.handleValueChange();
        this.$emit("submit");
      }
    }
  },
  mounted() {
    this.value = this.username;
    this.$nextTick(() => {
      if (this.$refs.usernameInput) {
        this.$refs.usernameInput.focus();
      }
    });
  }
}
</script>

<style lang="scss">
.username-step {
  max-width: 720px;

  &__description {
    margin-bottom: $px16;

    @include font-large;
  }

  &__form {
    margin-top: $px32;
  }

  &__input {
    width: 100%;
    padding: $px12 $px16;
    margin-bottom: $px8;

    border: 1px solid $grey-6;
    border-radius: $px4;

    font-size: 16px;

    &:focus {
      border-color: $blue-6;
      outline: none;
    }
  }

  &__input-hint {
    color: $grey-5;

    @include font-small;
  }
}
</style>
